/**
 * Insert `value` at the caret of a plain input / textarea (replacing any
 * selection) and put the caret after it. Returns the new field value; the
 * caller stores it. Falls back to appending when the element is not mounted.
 */
export function insertAtSelection(
  el: HTMLInputElement | HTMLTextAreaElement | null,
  current: string,
  value: string,
): string {
  if (!el) return current + value;
  const start = el.selectionStart ?? current.length;
  const end = el.selectionEnd ?? current.length;
  const next = current.slice(0, start) + value + current.slice(end);
  requestAnimationFrame(() => {
    el.focus();
    const pos = start + value.length;
    el.setSelectionRange(pos, pos);
  });
  return next;
}
